<template>
  <div class="artist-container" :style="{ backgroundImage: `url(${currentBackground})` }">
    <!-- 圖片預加載組件 -->
    <ImagePreloader 
      :images="allArtistImages"
      @preload-complete="handleImagePreloadComplete"
      @progress-update="handleProgressUpdate"
    />
    <div class="back-button" @click="$router.go(-1)">
      &#8592;
    </div>
    
    <div v-if="artist" class="artist-details">
      <h1 class="artist-name">{{ artist.name }}</h1>
      
      <div class="content-display" v-if="currentContent">
        <h3 class="content-title">{{ currentContent.title }}</h3>
        <p class="content-text">{{ currentContent.content }}</p>
      </div>
      
      <div class="thumbnail-selector">
        <div 
          v-for="(item, index) in artist.contentItems" 
          :key="index" 
          class="thumbnail-item"
          :class="{ active: currentContent === item }"
          @click="selectContent(item)"
        >
          <img :src="item.thumbnail" :alt="item.title" class="thumbnail-image">
          <div class="thumbnail-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    
    <div v-else class="not-found">
      <h2>未找到艺术家信息</h2>
      <button @click="$router.push('/artists')" class="back-to-artists">返回艺术家列表</button>
    </div>
  </div>
</template>

<script>
import ImagePreloader from '@/components/ImagePreloader.vue'

export default {
  name: 'ArtistPage',
  components: {
    ImagePreloader
  },
  data() {
    return {
      imagePreloadComplete: false,
      currentBackground: '',
      currentContent: null,
      allArtists: [
        { 
          id: 1, 
          name: '(ooo)', 
          contentItems: [
            {
              title: '周真臻 Jen Jen, Chou',
              content: '83%E的ESFP，喜歡觀察路人，心情不好的時候會去溜石頭溜滑梯，看電影一定到。',
              thumbnail: require('@/assets/images/artists/artist17.jpg'),
              background: require('@/assets/images/artists/artist7-1bg.jpg')
            },
            {
              title: '吳梓宣 Tzu Hsuan, Wu',
              content: '…@#$ ^&*()_+ ',
              thumbnail: require('@/assets/images/artists/artist15.jpg'),
              background: require('@/assets/images/artists/artist7-3bg.jpg')
            },
            {
              title: '吳宜璇 I Hsuan, Wu',
              content: '⋯：）',
              thumbnail: require('@/assets/images/artists/artist16.jpg'),
              background: require('@/assets/images/artists/artist7-2bg.jpg')
            }
          ]
        },
        { 
          id: 2, 
          name: '在呼', 
          contentItems: [
            {
              title: '林亞萱 Ya-Hsuan, Lin',
              content: '經歷：\n 2021～2024 森森觀察員',
              thumbnail: require('@/assets/images/artists/artist6.jpg'),
              background: require('@/assets/images/artists/artist3-1bg.jpg')
            },
            {
              title: '莊涵韻 Han-Yun, Chuang',
              content: '現實的理想主義者',
              thumbnail: require('@/assets/images/artists/artist5.jpg'),
              background: require('@/assets/images/artists/artist3-2bg.jpg')
            },
            {
              title: '黃翊庭 Yi-Ting, Huang',
              content: '懶得動，卻又努力拼湊著生活的碎片',
              thumbnail: require('@/assets/images/artists/artist7.jpg'),
              background: require('@/assets/images/artists/artist3-3bg.jpg')
            }
            
          ]
        },
        { 
          id: 3, 
          name: '無色體', 
          contentItems: [
            {
              title: '吳苡婕 Yi-Jie, Wu',
              content: '吳苡緁，蕉名是我最愛撒蕉，因為喜歡猴子所以喜歡香蕉。英文名字是Jamie，簡短來說是Jam，所以Banana Jam是我幫我自己取的名字。',
              thumbnail: require('@/assets/images/artists/artist13.jpg'),
              background: require('@/assets/images/artists/artist6-1bg.jpg')
            },
            {
              title: '葉承昀 Cheng-Yun, Yeh',
              content: '葉承昀，可以叫我MayYeh。還在思考存在的意義。',
              thumbnail: require('@/assets/images/artists/artist14.jpg'),
              background: require('@/assets/images/artists/artist6-2bg.jpg')
            }
          ]
        },
        { 
          id: 4, 
          name: 'Pān-Toh', 
          contentItems: [
            {
              title: '邱英英 Ying-Ying, Chiu',
              content: '多年人生經歷的堆積造就了我的腰痛和脊椎側彎，試著抒發但好像還是沒減緩。',
              thumbnail: require('@/assets/images/artists/artist10.jpg'),
              background: require('@/assets/images/artists/artist5-1bg.jpg')
            },
            {
              title: '詹登凱 Deng-Kai, Zhan',
              content: '希望生活可以多點樂趣，嘗試各種新鮮事物或技術。',
              thumbnail: require('@/assets/images/artists/artist8.jpg'),
              background: require('@/assets/images/artists/artist5-2bg.jpg')
            },
            {
              title: '黃安榕 An-Jung, Huang',
              content: '試圖讓人生跑馬燈精彩些。',
              thumbnail: require('@/assets/images/artists/artist9.jpg'),
              background: require('@/assets/images/artists/artist5-3bg.jpg')
            }
          ]
        },
        { 
          id: 5, 
          name: '予海', 
          contentItems: [
            {
              title: '黃壬煜 Jen-Yu, Huang',
              content: '以前是做著白日夢的小男孩，現在是白日才做夢的大男孩',
              thumbnail: require('@/assets/images/artists/artist28.jpg'),
              background: require('@/assets/images/artists/artist12-2bg.jpg')
            },
            {
              title: '陳冠儒 Guan-Ru, Chen',
              content: '是竹北人也是新竹人，是 INFP 也是 ENFP，伸縮自如，喜歡走路。在鏡頭和文字的世界徜徉是最自在的跋涉。',
              thumbnail: require('@/assets/images/artists/artist27.jpg'),
              background: require('@/assets/images/artists/artist12-1bg.jpg')
            }
          ]
        },
        { 
          id: 6, 
          name: '01110100 01101111', 
          contentItems: [
            {
              title: '賴榆方 Yu-Fang, Lai',
              content: '新北市新店人，喜歡收集路邊細小的詩意。22歲，帶著不完整而瑣碎的成熟，學習著與自己、他人、社會對話。',
              thumbnail: require('@/assets/images/artists/artist25.jpg'),
              background: require('@/assets/images/artists/artist11-1bg.jpg')
            },
            {
              title: '許煒晟 Wei-Cheng, Hsu',
              content: '2001年誕生的台南人，現就讀國立清華大學藝術學院學士班。駐足於媒體論、電影史學與攝影理論之間，試圖關心當代人類如何面對媒體與社會。創作則擅長即時影像設計、錄像、行為、表演。近期不務正業的癡迷於one liner。',
              thumbnail: require('@/assets/images/artists/artist26.jpg'),
              background: require('@/assets/images/artists/artist11-2bg.jpg')
            }
          ]
        },
        { 
          id: 7, 
          name: '氣氛大師', 
          contentItems: [
            {
              title: '陳威羽 Wei-Yu, Chen',
              content: '台北人，喜歡賽車運動，MBTI 是I啥的後面三個字母忘了，然後沒事別碰動機系，二專早點修。',
              thumbnail: require('@/assets/images/artists/artist21.jpg'),
              background: require('@/assets/images/artists/artist9-1bg.jpg')
            },
            {
              title: '陳庚宇 Geng-Yu, Chen',
              content: '我是陳庚宇，是個喜歡二次元的阿宅，我現在只想看買狗跟母雞卡第二季，拜託快點端上來罷，我甚麼都願意做。',
              thumbnail: require('@/assets/images/artists/artist20.jpg'),
              background: require('@/assets/images/artists/artist9-2bg.jpg')
            },
            {
              title: '林展毅 Zhan-Yi, Lin',
              content: '? 想怎樣',
              thumbnail: require('@/assets/images/artists/artist19.jpg'),
              background: require('@/assets/images/artists/artist9-3bg.jpg')
            }
          ]
        },
        { 
          id: 8, 
          name: '完美的代價', 
          contentItems: [
            {
              title: '彭鈺婷 Yu-Ting, Peng',
              content: '來自雲林的某個小村莊，喜歡說走就走的旅行，興趣是觀察天空跟月亮。最近在練習靠近自己真實的喜好。',
              thumbnail: require('@/assets/images/artists/artist4.jpg'),
              background: require('@/assets/images/artists/artist2-1bg.jpg')
            },
            {
              title: '楊 Zong-Ying, Yang',
              content: '自我認同是顆洋蔥，或是無尾熊\n目標是努力成為更厲害一點的人',
              thumbnail: require('@/assets/images/artists/artist3.jpg'),
              background: require('@/assets/images/artists/artist2-2bg.jpg')
            }
          ]
        },
        { 
          id: 9, 
          name: 'DR↺P', 
          contentItems: [
            {
              title: '蔡荃 Chuan, Tsai',
              content: '⁽⁽ ◟(∗ ˊωˋ ∗)◞ ⁾⁾睡門萬歲⁽⁽ ◟(∗ ˊωˋ ∗)◞ ⁾⁾',
              thumbnail: require('@/assets/images/artists/artist11.jpg'),
              background: require('@/assets/images/artists/artist4-1bg.jpg')
            },
            {
              title: '李姸蓁 Yen-Chen, Lee',
              content: '開心就好',
              thumbnail: require('@/assets/images/artists/artist12.jpg'),
              background: require('@/assets/images/artists/artist4-2bg.jpg')
            },   
          ]
        },
        { 
          id: 10, 
          name: '心願Yeast', 
          contentItems: [
            {
              title: '謝長穎 Chang-Ying, Hsieh',
              content: '試圖實踐簡單的生活與療癒的創作',
              thumbnail: require('@/assets/images/artists/artist18.jpg'),
              background: require('@/assets/images/artists/artist8-1bg.jpg')
            }          
          ]
        },
        { 
          id: 11, 
          name: '不會動的手臂', 
          contentItems: [
            {
              title: '馬渝婷 Yu-Ting, Ma',
              content: '一個喜歡活在規則外的人',
              thumbnail: require('@/assets/images/artists/artist1.jpg'),
              background: require('@/assets/images/artists/artist1-1bg.jpg')
            },
            {
              title: '劉綵荺 Tsai-Yun, Liu ',
              content: '享受觀察日常の瑣碎',
              thumbnail: require('@/assets/images/artists/artist2.jpg'),
              background: require('@/assets/images/artists/artist1-2bg.jpg')
            }
          ]
        },
        { 
          id: 12, 
          name: '沒什麼好想的', 
          contentItems: [
            {
              title: '何宜樺 Yi-Hua, Ho',
              content: '21歲，仍在與內心世界緩緩靠近、反覆對話。著迷於人與人、生理與心理之間的細膩牽繫，專注於生物藝術與動力機械的創作，在高敏的感知中，悄然茁壯，靜靜綻放。',
              thumbnail: require('@/assets/images/artists/artist22.jpg'),
              background: require('@/assets/images/artists/artist10-1bg.jpg')
            },
            {
              title: '吳勻楨 Yun-Jen, Wu',
              content: '藝術與設計、科技藝術、動力裝置、人機互動、使用者體驗、互動裝置、UIUX、創新創業...\n2025',
              thumbnail: require('@/assets/images/artists/artist23.jpg'),
              background: require('@/assets/images/artists/artist10-2bg.jpg')
            },
            {
              title: '黃麗穎 Li-Ying, Huang',
              content: '近期專攻研究新媒體藝術，擅長設計結構美感藝術，嘗試探究藝術動力裝置機械、以及電子硬體控制的可能性，也在生物藝術與擴增混合實境上發展藝術作品，主要的作品呈現方式為動力雕塑以及平面設計，作品多在探討人類社會問題，以及尋找新媒介科技與人類的衝突議題。有一種改變世界的使命感。',
              thumbnail: require('@/assets/images/artists/artist24.jpg'),
              background: require('@/assets/images/artists/artist10-3bg.jpg')
            }
          ]
        }
      ]
    }
  },
  computed: {
    artistId() {
      return parseInt(this.$route.params.id);
    },
    artist() {
      return this.allArtists.find(artist => artist.id === this.artistId);
    },
    // 收集所有藝術家圖片進行預加載
    allArtistImages() {
      const allImages = [];
      this.allArtists.forEach(artist => {
        artist.contentItems.forEach(item => {
          if (item.thumbnail) {
            allImages.push(item.thumbnail);
          }
          if (item.background) {
            allImages.push(item.background);
          }
        });
      });
      return allImages;
    }
  },
  methods: {
    // 處理圖片預加載完成
    handleImagePreloadComplete(data) {
      this.imagePreloadComplete = true;
      console.log(`藝術家頁面圖片預加載完成: ${data.loadedImages}/${data.totalImages}`);
    },
    
    // 處理預加載進度更新
    handleProgressUpdate(progress) {
      console.log(`藝術家圖片預加載進度: ${progress.toFixed(1)}%`);
    },
    
    selectContent(item) {
      this.currentContent = item;
      this.currentBackground = item.background;
    }
  },
  mounted() {
    if (this.artist && this.artist.contentItems.length > 0) {
      this.selectContent(this.artist.contentItems[0]);
    }
  }
}
</script>

<style scoped>
.artist-container {
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  transition: background-image 0.8s ease;
  position: relative;
  display: flex;
  flex-direction: column;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 50px;
  height: 50px;
  background-color: #004D6B;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 24px;
  font-weight: bold;
}

.back-button:hover {
  background-color: rgba(240, 131, 30, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
}

.artist-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px;
}

.artist-name {
  color:#004D6B ;
  font-size: 30px;
  margin-top: 60px;
  margin-bottom: 20px;
  text-shadow:  1px 1px 3px rgba(255, 255, 255);
}

.content-display {
  max-width: 600px;
  margin-top: auto;
  margin-bottom: 30px;
  background-color:transparent;
  padding: 20px;
  border-radius: 8px;
  color: white;
}

.content-title {
  color: rgb(240, 131, 30);
  font-size: 30px;
  margin-top: 0;
  margin-bottom: 10px;
  text-shadow:  1px 1px 3px rgba(0, 0, 0, 0.5);
}

.content-text {
  color: #004D6B;
  font-size: 22px;
  line-height: 1.6;
  margin: 0;
  text-shadow:  1px 1px 3px rgba(255, 255, 255);
}

.thumbnail-selector {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: auto;
}

.thumbnail-item {
  width: 200px;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0.7;
  background-color:#004d6b38 ;
}

.thumbnail-item:hover {
  opacity: 1;
  transform: translateY(-10px);
}

.thumbnail-item.active {
  opacity: 1;
  box-shadow: 0 0 0 3px rgba(240, 131, 30, 0.9);
}

.thumbnail-image {
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.thumbnail-title {
  padding: 8px;
  text-align: center;
  font-size: 12px;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
}

.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.back-to-artists {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  transition: all 0.3s ease;
}

.back-to-artists:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

@media (max-width: 768px) {
  .artist-name {
    font-size: 36px;
  }
  
  .thumbnail-item {
    width: 80px;
  }
  
  .thumbnail-image {
    height: 60px;
  }
  
  .artist-details {
    padding: 20px;
  }
  
  .content-display {
    max-width: 100%;
  }
}
</style>